const setPlaceholder = (inputElem, tip, textareaIndex) => {
    if (!inputElem) {
        return;
    }
    if (inputElem.length === 0) {
        return;
    }
    if (inputElem.children && inputElem.children.length > 0) {
        inputElem = inputElem.children[textareaIndex || 0];
    } else {
        inputElem = Array.isArray(inputElem) ? inputElem[0] : inputElem;
    }
    inputElem?.setAttribute('placeholder', tip);
};
export default setPlaceholder;
